module.exports = __webpack_public_path__ + "static/media/calendar.fb9da95b.svg";